class UpsellHotelAddedEvent {
  originalHotelCode: string;

  originalRoomCode: string;

  upsoldHotelCode: string;

  upsoldRoomCode: string;

  upsellDeltaAmount: number;

  upsellDeltaCurrency: string;
}

export default UpsellHotelAddedEvent;
